module.exports = __webpack_public_path__ + "static/media/25.486ef889.mp3";